// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"152":"base","332":"detail"}[chunkId] + "." + {"152":"c17c51ed","332":"cb1d9556"}[chunkId] + ".js";
};